import { __rest } from "tslib";
import React from 'react';
import './index.scss';
const SiriusRadio = (_a) => {
    var { disabled = false, checked = false, children } = _a, restProps = __rest(_a, ["disabled", "checked", "children"]);
    const isChecked = checked ? 'checked' : 'normal';
    const checkClassName = disabled ? 'disabled' : isChecked;
    return (React.createElement("div", { className: "sirius-radio-wrap" },
        React.createElement("div", Object.assign({ className: `sirius-radio ${checkClassName}` }, restProps)),
        children && React.createElement("div", { className: "sirius-radio-name" }, children)));
};
export default SiriusRadio;
